// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_expansion-panel.styl
// module id = 187
// module chunks = 0